import { FC } from 'react';
import { Radio, Typography } from '@flash-tecnologia/hros-web-ui-v2';
import { RowContainer } from './Containers';

interface RadioButtonProps {
  label: string;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void;
  checked: boolean;
  value: unknown;
}

export const RadioButton: FC<RadioButtonProps> = ({
  label,
  onChange,
  checked,
  value,
}) => {
  return (
    <RowContainer style={{ alignItems: 'center', marginRight: '15px' }}>
      <Radio checked={checked} value={value} onChange={onChange} />
      <Typography
        variant="body3"
        style={{ fontWeight: '600', color: '#53464F' }}
      >
        {label}
      </Typography>
    </RowContainer>
  );
};
